import React from 'react';
import './Rolemanagement.css';
import UserRoleAssignment from './UserRoleAssignment';

const UserRoleAssignmentPage = () => {
    return (
        <div className="rm-page" style={{ paddingTop: 14 }}>
            <UserRoleAssignment allowedModuleCodes={["SELFCARE"]} />
        </div>
    );
};

export default UserRoleAssignmentPage;
